import React, { lazy } from "react";
import { Route, Redirect } from "react-router-dom";
import ForgotPassword from "./components/forgotPassword";
import ConfirmForgotPassword from "./components/confirmForgotPassword";
import CurrentUser from "./components/Users/current-user";
import LazyRoute from "./utils/LazyRoute";

const ImportExport = lazy(() => import("./components/Import-Export"));
const SiteMetrics = lazy(() => import("./components/Dashboard/Site Metrics"));
const AWSMetrics = lazy(() => import("./components/Dashboard/AWS"));
const StudioWrapper = lazy(() => import("./components/Shared/StudioWrapper"));
const Screensaver = lazy(() => import("./components/Screensaver"));
const PreciousPricingCalculator = lazy(() => import("./components/Precious-Pricing-Calculator"));
const PriceScraper = lazy(() => import("./components/Price-Scraper"));
const MagicNumberSearch = lazy(() => import("./components/MagicNumberSearch"));

export default [
  <Route key="forgot-password" exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route
    key="confirm-password"
    exact
    path="/confirm-password"
    component={ConfirmForgotPassword}
    noLayout
  />,
  <Route key="profile" path="/profile" component={CurrentUser} exact />,
  <Route
    key="bulk-products"
    path="/bulk-products"
    render={(routeProps) => <LazyRoute component={ImportExport} {...routeProps} />}
    exact
  />,
  <Route
    key="sort-order"
    path="/sort-order"
    exact
    render={() => <Redirect to="/ring-material-sort-order" />}
  />,
  <Route
    key="precious-pricing-calculator"
    path="/precious-pricing-calculator"
    render={(routeProps) => <LazyRoute component={PreciousPricingCalculator} {...routeProps} />}
    exact
  />,
  <Route
    key="screensaver"
    path="/screensaver"
    render={(routeProps) => <LazyRoute component={Screensaver} {...routeProps} />}
    exact
  />,
  <Route
    path="/magic-number-search"
    render={(routeProps) => <LazyRoute component={MagicNumberSearch} {...routeProps} />}
    exact
  />,
  <Route
    key="export-product-price"
    path="/export-product-price"
    render={(routeProps) => <LazyRoute component={PriceScraper} {...routeProps} />}
    exact
  />,
  <Route
    key="dashboard-site"
    path="/dashboard/site"
    render={(routeProps) => <LazyRoute component={SiteMetrics} {...routeProps} />}
    exact
  />,
  <Route
    key="dashboard-application"
    path="/dashboard/application"
    render={(routeProps) => <LazyRoute component={AWSMetrics} {...routeProps} />}
    exact
  />,
  <Route
    key="studio-wrapper"
    path={["/signet-studio", "/design-pattern-studio"]}
    render={(routeProps) => <LazyRoute component={StudioWrapper} {...routeProps} />}
  />,
];
